import React, { createContext, useState, useEffect } from 'react';
import { I18n } from '@aws-amplify/core';
import { dict } from '../i18/dictionnary';
const initialState = {};
const store = createContext(initialState);
const { Provider } = store;

I18n.putVocabularies(dict);

const LocalizationProvider = (props) => {
	const { children } = props;
	const [ lan, setLanguage ] = useState('en');
	
	useEffect(
		() => {
			I18n.setLanguage(lan);
		},
		[ lan ]
	);

	useEffect(() => {
		I18n.setLanguage(lan);
	});


	return (
		<Provider
			value={{
				I18n,
				setLanguage
			}}
		>
			{children}
		</Provider>
	);
};
export { store, LocalizationProvider };
